export const PULL_THRESHOLD = 80;
export const MAX_PULL_DISTANCE = 130;
export const RESISTANCE_FACTOR = 0.4;
export const REFRESH_HOLD_DISTANCE = 70;
